<template>
	<div class="pa-3">
		<div class="v-table__overflow">
		    <table class="v-datatable v-table theme--light imported-csv-table">
		        <thead>
		            <tr>
		            	<th role="columnheader" class="column">#</th>
		            	<th role="columnheader" class="column">username</th>
	                	<th v-for="(column, index) in columns" v-if="!skippedIndexes.includes(index)" role="columnheader" class="column" :data-column-title="`${stripQuotes(column.title)}`">{{ column.title }}</th>
		            </tr>
		        </thead>
		        <tbody>
		            <tr v-for="(row, rowIndex) in filteredRows">
		            	<td>{{ seqNo(rowIndex) }}</td>
		            	<td>{{ (row.hasOwnProperty('user') && row.user) ? row.user.username : '&nbsp;' }}</td>
		                <td v-for="(column, index) in row.columns" v-if="!skippedIndexes.includes(index)">{{ column.pivot.content }}</td>
		            </tr>
		        </tbody>
		    </table>
		</div>

	    <div class="text-xs-right pt-2">
			<v-pagination v-model="currentPage" :length="pages" :total-visible="6"></v-pagination>
	    </div>
	</div>
</template>

<script>
	import * as config from '@/config'

	const numberFormat = function(value) {
	  	return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
	}

	export default {
		props: {
			fileId: {
				type: Number,
				default: null
			}
		},
		data () {
			return {
				columns: [],
				rows: [],
				currentPage: 1,
				pageSize: 10,
			}
		},
		computed: {
			skippedIndexes () {
				return this.columns.map((c, i) => {
					return ['token', 'ref', 'Network ID'].includes(c.title) ? i : null
				}).filter(c => c)
			},
			pages () {
				if (!this.pageSize) {
					return 0
				}
				return Math.ceil(this.rows.length / this.pageSize)
			},
			filteredRows () {
				return this.rows.slice((this.currentPage - 1) * this.pageSize, ((this.currentPage - 1) * this.pageSize) + this.pageSize)
			},
		},
		methods: {
	    	seqNo (index) {
				return numberFormat(this.rows.length - ((this.currentPage - 1) * this.pageSize) - index)
	    	},
			stripQuotes (text) {
				return text.replace(/["']/g, "")
			},
			refreshTable () {
	        	axios.get(`${config.BASE_URL}/csv/${this.fileId}`)
	        		.then(response => {
	        			this.columns = response.data.data.columns
	        			this.rows = response.data.data.rows
	        		})
	        		.catch(error => {
	        			this.loading = false
	        		})
			}
		},
		mounted () {
			if (this.fileId) {
				this.refreshTable()
			}
		},
		watch: {
			fileId (newValue) {
				if (newValue) {
					this.refreshTable()
				}
			}
		}
	}
</script>

<style lang="scss">
	.imported-csv-table {
		max-width: unset;
		width: unset;

		th[data-column-title="comment"] {
			min-width: 340px !important;
		}
	}
</style>